/**
 * MisLeads - Página completa de gestión de leads para asesores
 */

import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { collection, query, where, getDocs } from 'firebase/firestore'
import { db } from '../../firebaseConfig'

import UserNav from '../../components/navbar/user-nav'
import AdminSidebar from '../../components/admin-sidebar'
import FooterTop from '../../components/footer-top'
import Footer from '../../components/footer'

import PageTitle from '../../components/page-title'
import { FullPageLoading } from '../../components/loading-states'
import LeadsDashboard from '../../components/LeadsDashboard'

export default function MisLeads() {
  const [show, setShow] = useState(false)
  const [perfil, setPerfil] = useState<any>(null)
  const [nombreInmobiliaria, setNombreInmobiliaria] = useState('')
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  useEffect(() => {
    const auth = getAuth()
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate('/login')
        return
      }

      const tipos = ['asesor', 'asociado']

      for (const tipo of tipos) {
        const q = query(collection(db, tipo), where('correo', '==', user.email))
        const snapshot = await getDocs(q)
        if (!snapshot.empty) {
          const docSnap = snapshot.docs[0]
          const data = docSnap.data()
          const perfil_id = docSnap.id
          setPerfil({ ...data, tipo, perfil_id })

          // Obtener nombre de inmobiliaria
          const inmobiliariaDocId = tipo === 'asesor'
            ? (Array.isArray(data.inmobiliaria_doc_ids) ? data.inmobiliaria_doc_ids[0] : data.inmobiliaria_doc_ids)
            : data.inmobiliaria_doc_id

          if (inmobiliariaDocId) {
            try {
              const { doc: docFn, getDoc } = await import('firebase/firestore')
              const inmoDocRef = docFn(db, 'inmobiliaria', inmobiliariaDocId)
              const inmoSnap = await getDoc(inmoDocRef)
              if (inmoSnap.exists()) {
                setNombreInmobiliaria(inmoSnap.data().nombre || '')
              }
            } catch (error) {
              console.error('Error al obtener la inmobiliaria:', error)
            }
          }

          setLoading(false)
          return
        }
      }

      // Si no tiene perfil
      setLoading(false)
    })

    return () => unsubscribe()
  }, [navigate])

  if (loading) {
    return <FullPageLoading message="Cargando leads..." />
  }

  if (!perfil) {
    return (
      <>
        <UserNav />
        <PageTitle title="Acceso denegado" subtitle="No tienes un perfil de asesor" />
        <section className="py-5">
          <div className="container">
            <div className="alert alert-warning">
              <i className="fa-solid fa-triangle-exclamation me-2"></i>
              No tienes un perfil de asesor o asociado activo.
            </div>
          </div>
        </section>
        <Footer />
      </>
    )
  }

  return (
    <>
      <UserNav nombreUsuario={perfil?.nombre} nombreInmobiliaria={nombreInmobiliaria} />

      <PageTitle
        title="Mis Leads"
        subtitle="Gestiona las consultas de clientes interesados en tus propiedades"
      />

      <section className="py-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="filter_search_opt">
                <button
                  className="btn btn-dark full-width mb-4"
                  onClick={() => setShow(!show)}
                >
                  Dashboard Navigation<i className="fa-solid fa-bars ms-2"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-12">
              <AdminSidebar
                show={show}
                setShow={setShow}
                nombre={perfil?.nombre}
                inmobiliaria={nombreInmobiliaria}
              />
            </div>

            <div className="col-lg-9 col-md-12">
              <div className="card border-0 rounded-4 shadow-sm">
                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">
                    <i className="fa-solid fa-envelope-open-text me-2"></i>
                    Leads de mis propiedades
                  </h5>
                </div>
                <div className="card-body">
                  <LeadsDashboard
                    asesorId={perfil.perfil_id}
                    variant="full"
                    maxItems={50}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  )
}
